import React, {Component, useRef} from 'react';

import { separate } from '../../helpers/separate';

import './styles/card.scss';
import {bindActionCreators} from "redux";
import {setPromocode, setStudentStatus, switchInstallmentDiscount, switchMilleniumClub} from "../../actions/card";
import {connect} from "react-redux";
import {changeTypeOfModal, openModal, saveModalInfo} from "../../actions/modals";
import {eventSelectCard} from "../../helpers/analytics";
import {setResultCard} from '../../actions/card';
import Tooltip from "../Tooltip/tooltip";
import Countdown from "../Countdown/Countdown";
import axios from "axios";

class Card extends Component {

    state = {
      cardTooltipActive : false,
      promocodeTooltipActive: false
    }

    openTooltip() {
        this.setState({'cardTooltipActive': true})
    }

    copyPromocode(code = '', discount = 0) {
        if (code !== '') {
          navigator.clipboard.writeText(code)
          this.props.setPromocode({
            'code': code,
            'discount': discount
          })
        }

        var self = this
        this.setState({'promocodeTooltipActive': true})

        setTimeout(function() {
            self.setState({'promocodeTooltipActive': false})
        }, 2000);
    }

    switchInstallmentDiscount(status) {
      if (!this.props.studentStatus) {
        this.props.switchInstallmentDiscount(status)
        if (status) {
          this.props.setStudentStatus(false)
        }
      }
    }

    switchStudentStatus(status) {
      this.props.setStudentStatus(status)
      if (status) {
        this.props.switchInstallmentDiscount(false)
      }
    }

    openWidgetForm(siteWidgetData) {
        let formParams = {
            widgetType: siteWidgetData.widget_type,
            widgetSlug: siteWidgetData.widget_slug,
            totalWheelSectorAmount: siteWidgetData.total_wheel_sector_amount,
            title: siteWidgetData.form.title,
            text: siteWidgetData.form.text,
            image: siteWidgetData.form.image,
            buttonCaption:siteWidgetData.form.button_caption,
            widgetActiveUntil: siteWidgetData.active_until, //for cookie expire
            successTitle: siteWidgetData.form.success_title,
            successText: siteWidgetData.form.success_text,
            successImage: siteWidgetData.form.success_image,
            failTitle: siteWidgetData.form.fail_title,
            failText: siteWidgetData.form.fail_text,
            discounts: siteWidgetData.discounts,
            image_submit_animation: siteWidgetData.form.image_submit_animation,
            winPresentLabel: siteWidgetData.form.win_present_label,
            winPresentLabelPlace: siteWidgetData.form.win_present_label_place,
            winExistsTitle: siteWidgetData.form.win_exists_title
        }

        this.props.saveModalInfo(formParams);
        this.props.changeTypeOfModal('widgetForm');
        this.props.openModal();
    }

    renderWidget(position) {

        const expiresDateArr = this.props.expires.split('.'),
            expiresDate = new Date('20' + expiresDateArr[2] + '-' + expiresDateArr[1] + '-' + expiresDateArr[0] + ' 23:59:59');
        const self = this;

        return (
            this.props?.widgets?.[position]?.length ? (
                <div className={`${position}-widgets sale-price-widgets`}>
                    {
                        this.props.widgets[position].map(item => {
                            return (
                                <div className={item.promocode ? "offers__promocode-widget" : (item.show_gamelead || item.widget_id ? "gamelead-container" : "sale-price-placeholder-cont")}
                                     onClick={function() {
                                         if(item.promocode) self.copyPromocode(item.promocode.promocode, item.promocode.discount);
                                         // eslint-disable-next-line no-undef
                                         else if (item.show_gamelead && (typeof GameLead !== 'undefined' && typeof GameLead === 'function')) GameLead();
                                         else if (item.site_widget) self.openWidgetForm(item.site_widget);
                                         else return false;
                                     }}
                                >
                                    <img src={item.image}
                                         alt=''
                                         className={`sale-price-placeholder ${item.animation ?? ""}`}
                                         id="sale-price-placeholder" />
                                    {
                                        item.show_timer ? <Countdown date={item.timer_date_until ? new Date(item.timer_date_until) : expiresDate} /> : ""
                                    }
                                    {
                                        item.promocode ? <div className={'copy-tooltip ' + (self.state.promocodeTooltipActive ? 'active' : '')}>Промокод скопирован</div> : ""
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            ) : ''
        );
    }

    render() {
        const {
            milleniumAdded,
            milleniumAddedGlobal,
            installmentDiscount,
            changeTypeOfModal,
            openModal,
            saveModalInfo,
            history,
            setResultCard,
            expandIncludes,
            studentStatus
        } = this.props;

        let totalAmount = Math.round(
            this.props.visit_count_fixed && this.props.cost_fixed
                ? (this.props.cost_fixed + (milleniumAdded ? this.props.millenium_add_fixed_price : 0)) * this.props.visit_count_fixed
                : (this.props.cost_month_base + (milleniumAdded ? this.props.millenium_add_price : 0)) * (this.props.base_months + this.props.base_freezing_months)
        )

        let totalAmountOld = this.props.card.cost_month_old ? Math.round(
          this.props.card.cost_month_old + (milleniumAdded ? this.props.card.millenium_add_price_old : 0)) * (this.props.base_months + this.props.base_freezing_months
        ) : 0

        let perUnitAmount = Math.round(
            this.props.visit_count_fixed && this.props.card.show_cost_fixed && this.props.cost_fixed
                ? this.props.cost_fixed + (milleniumAdded ? this.props.millenium_add_fixed_price : 0)
                : this.props.cost_month_base + ( milleniumAdded ? this.props.millenium_add_price : 0)
            )

        let perUnitAmountOld = this.props.card.cost_month_old ? Math.round(
            this.props.card.cost_month_old + (milleniumAdded ? this.props.card.millenium_add_price_old : 0)
        ) : 0

        const availableInstallments = this.props.installments ? this.props.installments.filter(installment => {
          return installment.for_new;
        }) : []

        let oldPriceDiscount = 0

        if (installmentDiscount && availableInstallments.length > 0) {
          oldPriceDiscount = availableInstallments[0].markup_new
        } else if (studentStatus && this.props.card.student_discount) {
          oldPriceDiscount = this.props.card.student_discount
        } else if (this.props.unconditional_discount > 0) {
          oldPriceDiscount = this.props.unconditional_discount
        }

        if (oldPriceDiscount > 0) {
          totalAmountOld = totalAmount
          totalAmount = Math.round(totalAmount - totalAmount * oldPriceDiscount / 100)
          perUnitAmount = Math.round(perUnitAmount - perUnitAmount * oldPriceDiscount / 100)

          oldPriceDiscount = perUnitAmountOld ? Math.floor(
              (perUnitAmountOld - perUnitAmount) / perUnitAmountOld * 100
          ) : 0
        }

        const handleClickOutside = (e, id, title) => {
            if (e.target.className !== 'card-tooltip' && e.target.className !== 'card-tooltip-toggle' && this.state.cardTooltipActive) {
                this.setState({'cardTooltipActive': false})
            }
        }

        document.addEventListener('click', handleClickOutside);

        const expiresDateArr = this.props.expires.split('.'),
            expiresDate = new Date('20' + expiresDateArr[2] + '-' + expiresDateArr[1] + '-' + expiresDateArr[0] + ' 23:59:59')

        return (
          <div
            className={`your-offer ${this.props.subscription ? 'your-offer--subscription' : ''} ${this.props.title == 'SALE' ? 'your-offer--new-year-sale' : ''} ${this.props.gift ? 'your-offer--gift' : ''}`}>
              <div className="your-offer__header">
                  { /* this.props.title == 'SALE' ? <img src={require('../../static/images/new-year/snow-up.png')} alt=''
                                                     className="sale-snow-up"/> : '' */}
                  <div className="your-offer__title">
                      <h3 className={this.props.header_class}
                          onClick={() => {
                              setResultCard({...this.props.card});
                              eventSelectCard({...this.props.card});
                              /*
                              //Это не работает в mobile safari - блокируется прокрутка
                              if (document.getElementsByClassName('marquiz-widget').length > 0) {
                                  document.getElementsByClassName('marquiz-widget')[0].style.display = 'none'
                              }
                              if (document.getElementsByClassName('marquiz__bg').length > 0) {
                                  document.getElementsByClassName('marquiz__bg')[0].style.display = 'none'
                              }
                               */
                              history.push('/processing/' + this.props.card.slug);
                          }}
                      >{this.props.title}{this.props.title == 'Подписка' ?
                        <span style={{color: '#ff2323', marginLeft: '20px'}}>NEW</span> : ''}</h3>
                  </div>
                  <div className="duration">
                      {this.props.test_drive ? '1 день' :
                        this.props.subscription ?
                          <div>
                              <div>
                                  Оплата помесячно <Tooltip
                                text="Абонемент с оплатой раз в месяц. Посещайте выбранный клуб с мультидоступом ещё в три клуба. По расходам на физкультурно-оздоровительные услуги налогоплательщику предоставляется социальный вычет в размере 13%"/>
                              </div>
                              <div className="automatic-renew-comment">Автоматическое продление <Tooltip
                                text="Автоматические платежи с банковской карты всегда можно отменить."/>
                              </div>
                          </div>
                          : <div>
                              {this.props.visit_count_fixed &&
                                <p>{separate(Math.round(this.props.visit_count_fixed))} посещени{String(this.props.visit_count_fixed).endsWith(1) ? 'е' : ('234'.includes(String(this.props.visit_count_fixed).substr(-1, 1)) ? 'я' : 'й')}
                                </p>}
                              <div
                                style={{position: "relative"}}>{separate(Math.round(this.props.base_months))} месяц{this.props.base_months > 4 ? 'ев' : (this.props.base_months > 1 ? 'а' : '')}
                                  {this.props.comfort ?
                                    <span>
                                        <img src={require('../../static/images/icons/info.svg').default}
                                             className="card-tooltip-toggle" onClick={this.openTooltip.bind(this)}/>
                                        <div
                                          className={'card-tooltip ' + (this.state.cardTooltipActive ? 'active' : '')}>
                                            <b>Время посещения ограничено</b>
                                            <br/><br/>Доступ в клуб в будние дни:
                                            <ul style={{paddingLeft: '15px', marginTop: '5px'}}>
                                                <li>с 7:00 до 17:00 (FITRON Газетный с 6:00 до 17:00)</li>
                                                <li>с 21:00 до 23:00</li>
                                            </ul>
                                            <br/>Выходные и праздничные дни без ограничений
                                        </div>
                                    </span> : ''}
                                  {this.props.card.youth ?
                                      <span>
                                        <img src={require('../../static/images/icons/info.svg').default}
                                             className="card-tooltip-toggle" onClick={this.openTooltip.bind(this)}/>
                                        <div className={'card-tooltip ' + (this.state.cardTooltipActive ? 'active' : '')}>
                                            <b>Только для клиентов возрастом от 15 до 18 лет</b>
                                            <br/><br/><b>Время посещения ограничено</b>
                                            <br/>Доступ в клуб с 7:00 до 17:00
                                            <br/>(FITRON Газетный с 6:00 до 17:00)
                                        </div>
                                    </span> : ''}
                              </div>
                              {this.props.base_freezing_months > 0 ? <p>+{this.props.base_freezing_months * 30} дней заморозки</p> : ''}
                          </div>
                      }
                  </div>
                  {
                      this.props.widgets?.top?.length ?
                        this.renderWidget('top') : (
                              this.props.withExpiresBlock && this.props.card.slug != 'hot' ? (
                                  <div className="expires">
                                      {
                                          this.props.title == 'Ночной' ? <span>ТОЛЬКО ЭТОЙ НОЧЬЮ!</span> :
                                              (this.props.expires ? <span>Акция действует до {this.props.expires}</span> : '')
                                      }
                                      {/* {this.props.title == 'Ultra' ? <b><br/>Скидка 10% по промокоду 2024</b> : ''} */}
                                  </div>
                              ) : ''
                          )
                  }
                  {
                    /*
                    this.props.unconditional_discount == 5 ?
                      <div className="offers__promocode-widget" onClick={() => {
                          this.copyPromocode()
                      }}>
                          <img src={require('../../static/images/discount/5-percent-red.svg').default} className="freezing-gift"/>
                          <div className={'copy-tooltip ' + (this.state.promocodeTooltipActive ? 'active' : '')}>Скидка активирована</div>
                      </div>
                      : ''
                     */
                  }
                  {/*
                      this.props.title === 'Индивидуальный' ?
                          <img src={require('../../static/images/gamelead-april.svg').default} alt=''
                               className="gamelead-sticker"
                              // eslint-disable-next-line no-undef
                               onClick={function () {GameLead()}}/>
                          : ''
                  */}
                  {
                      this.props.card.slug == 'individualnyi' && (new Date()) < (new Date('2025-08-11')) ?
                          <div className="offers__promocode-widget" onClick={() => {
                              this.copyPromocode('ФИЗКУЛЬТ', 2004)
                          }}>
                              <img src={require('../../static/images/promocode/fizkult-sticker.png')} className="freezing-gift"/>
                              <div className={'copy-tooltip ' + (this.state.promocodeTooltipActive ? 'active' : '')}>Промокод скопирован</div>
                          </div>
                          : ''
                  }
                  {
                      this.props.card.available_quantity ?
                          <div className="available-quantity-sticker">
                              {this.props.card.available_quantity == 1 ? <span>Осталась<br/>1 карта</span> : ''}
                              {
                                  this.props.card.available_quantity > 1 && this.props.card.available_quantity < 5
                                      ? <span>Осталось<br/>{this.props.card.available_quantity} карты</span>
                                      : ''
                              }
                              {
                                  this.props.card.available_quantity > 4 && this.props.card.available_quantity < 21
                                      ? <span>Осталось<br/>{this.props.card.available_quantity} карт</span>
                                      : ''
                              }
                              {
                                  this.props.card.available_quantity > 20 ? (
                                      this.props.card.available_quantity % 10 === 1 ?
                                          <span>Осталась<br/>{this.props.card.available_quantity} карта</span>
                                          : (
                                              this.props.card.available_quantity % 10 > 1 && this.props.card.available_quantity % 10 < 5
                                                  ? <span>Осталось<br/>{this.props.card.available_quantity} карты</span>
                                                  : <span>Осталось<br/>{this.props.card.available_quantity} карт</span>
                                          )
                                  ) : ''
                              }
                          </div> : (
                              this.props.includes.freezing_30_days ?
                                  <img src={require('../../static/images/cards/freezing-gift.png')}
                                       className="freezing-gift animated"
                                       alt=""/> : (
                                      !(!this.props.subscription && oldPriceDiscount && !this.props.unconditional_discount) && this.props.widgets?.['center-right']?.length ? this.renderWidget('center-right') : ""
                                  )
                          )



                      /*
                      this.props.title === 'Семейный' ?
                          <img src={require('../../static/images/discount/10-percent-family.svg').default} alt='' className="freezing-gift" />
                          : ''
                  }
                  {
                      this.props.title === 'Ночной' ?
                          <img src={require('../../static/images/discount/until-900.png')} alt='' className="freezing-gift" />
                          : ''
                  }
                  {
                    this.props.card.slug == 'cosmos' ?
                      <div className="offers__promocode-widget" onClick={() => {
                        this.copyPromocode('COSMOS', 11)
                      }}>
                        <img src={require('../../static/images/promocode/cosmos-11-sticker.svg').default} className="freezing-gift"/>
                        <div className={'copy-tooltip ' + (this.state.promocodeTooltipActive ? 'active' : '')}>Промокод скопирован</div>
                      </div>
                      : ''
                  }
                  {
                    this.props.card.slug == 'pioner' ?
                      <div className="offers__promocode-widget" onClick={() => {
                        this.copyPromocode('MIR', 11)
                      }}>
                        <img src={require('../../static/images/promocode/mir-11-sticker.svg').default} className="freezing-gift"/>
                        <div className={'copy-tooltip ' + (this.state.promocodeTooltipActive ? 'active' : '')}>Промокод скопирован</div>
                      </div>
                      : ''
                  */}
                  {
                      this.props.widgets?.center?.length ? this.renderWidget('center') : (
                          this.props.card.slug == 'sale' || this.props.card.slug == 'hot' ?
                              (
                                  this.props.card.slug == 'hot' ?
                                      <div className="sale-price-placeholder-cont">
                                          <img src={require('../../static/images/price-placeholder-countdown' + (this.props.unconditional_discount == 30 ? '-30' : '') + '.png')} alt=''
                                               className="sale-price-placeholder" id="sale-price-placeholder"
                                          />
                                          <Countdown date={expiresDate} />
                                      </div> :
                                      <img src={require('../../static/images/price-placeholder-50.png')} alt=''
                                           className="sale-price-placeholder" id="sale-price-placeholder"
                                          // eslint-disable-next-line no-undef
                                             onClick={function () {GameLead()}}
                                      />
                              ):
                              (
                                  this.props.subscription ?
                                <div className="price">
                                    <div className="price">
                                        <div className="full">
                                            <div className="amount">
                                                {`${separate(Math.round(this.props.cost_month_base + (milleniumAdded ? this.props.millenium_add_price : 0)))}`} ₽
                                                {/*<span className="old-price">{separate(Math.round(this.props.cost_month_base + 600 + (milleniumAdded ? this.props.millenium_add_price : 0)))} ₽</span>*/}
                                            </div>
                                            <div className="comment">Со второго месяца</div>
                                        </div>
                                        <div className="month">
                                            <div className="amount">
                                                {`${separate(Math.round(this.props.subscription_cost_first_month + (milleniumAdded ? this.props.millenium_add_first_month_price : 0)))}`} ₽
                                                {/*<span className="old-price">{`${separate(Math.round(this.props.subscription_cost_first_month + 600 + (milleniumAdded ? this.props.millenium_add_first_month_price : 0)))}`} ₽</span>*/}
                                            </div>
                                            <div className="comment">За первый месяц</div>
                                        </div>
                                    </div>
                                </div> :
                                (
                                  this.props.test_drive ?
                                    <div className="price">
                                        <div className="full">
                                            <div className="amount"><s className="testdrive-discount">&nbsp;&nbsp;1 000
                                                ₽&nbsp;&nbsp;</s></div>
                                            <div className="comment">Без скидки</div>
                                        </div>
                                        <div className="month">
                                            <div
                                              className="amount">{`${separate(Math.round(this.props.cost_fixed))}`} ₽
                                            </div>
                                            <div className="comment">Со скидкой</div>
                                        </div>
                                    </div> : (
                                      this.props.title == 'SALE' ?
                                        <div className="discount">
                                            до <span className="amount">-40%</span>
                                        </div> :
                                        <div className="price">
                                            <div className="full">
                                                {
                                                  perUnitAmountOld || oldPriceDiscount ?
                                                    <div className="amount">
                                                        {perUnitAmountOld ? <span className="old-price-month">{separate(perUnitAmountOld)} ₽</span> : ''}
                                                        {oldPriceDiscount && !this.props.unconditional_discount ? <span className="old-price-discount">-{oldPriceDiscount}%</span> : ''}
                                                    </div> :
                                                    <div>
                                                      <div className="amount">{
                                                        `${separate(totalAmount)}`
                                                      } ₽
                                                        {totalAmountOld && !this.props.unconditional_discount ? <span className="old-price">{separate(totalAmountOld)} ₽</span> : ''}
                                                      </div>
                                                      <div className="comment">Полная стоимость</div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="month">
                                                <div
                                                  className="amount">{`${separate(Math.round(perUnitAmount))}`} ₽
                                                </div>
                                                <div
                                                  className="comment">{this.props.visit_count_fixed && this.props.card.show_cost_fixed ? 'Стоимость одного посещения' : 'Стоимость одного месяца'}</div>
                                            </div>
                                        </div>
                                    )
                                )
                            )
                      )
                  }

                  {
                      this.props.widgets?.bottom?.length ?
                          this.renderWidget('bottom') : (
                            availableInstallments.length > 0 && availableInstallments[0].markup_new > 0 ?
                              <div className={'installment-toggle' + (studentStatus ? ' _disabled' : '')}>
                                <div className={installmentDiscount ? '' : 'active'} onClick={e => {
                                  this.switchInstallmentDiscount(false)
                                }}>
                                  Рассрочка от клуба <Tooltip text={'Рассрочка на 5 частей от клуба, 100% одобрение, без переплат. Акция действует до '+this.props.expires} />
                                </div>
                                <div className={installmentDiscount ? 'active' : ''} style={{paddingTop: '16px'}} onClick={e => {
                                  this.switchInstallmentDiscount(true)
                                }}>
                                  Скидка {availableInstallments[0].markup_new}%
                                </div>
                              </div> :
                              <div className="dolyame-badge-cont">
                                {
                                  this.props.tinkoff_credit_available && (!this.props.tinkoff_loan_available || !this.props.dolyame_available) ? (
                                      <div className="badge"
                                           onClick={e => {
                                               changeTypeOfModal('creditInfo');
                                               openModal();
                                           }}>Кредит</div>
                                  ) : ''
                                }
                                {
                                  this.props.tinkoff_loan_available ?
                                    <div className="badge" onClick={e => {
                                      saveModalInfo({
                                        amount: totalAmount
                                      })
                                      changeTypeOfModal('tinkoffLoanInfo');
                                      openModal();
                                    }}>Рассрочка</div>
                                    : ''
                                }
                                {
                                  this.props.dolyame_available ?
                                    <div className="badge" onClick={e => {
                                      saveModalInfo({
                                        amount: totalAmount
                                      })
                                      changeTypeOfModal('dolyameInfo');
                                      openModal();
                                    }}>Оплата долями</div>
                                    : ''
                                }
                                {
                                   availableInstallments.length > 0 ?
                                       <div className="badge"
                                            onClick={e => {
                                                changeTypeOfModal('clubLoanInfo');
                                                openModal();
                                            }}>Рассрочка от клуба</div>
                                       : ''
                                }
                              </div>
                          )
                  }

                {
                  this.props.card.student_discount ?
                    <div className="student-toggle" onClick={e => this.switchStudentStatus(!studentStatus)}>
                      <div className={'toggle-button' + (studentStatus ? ' _active' : '')}></div>
                      Я студент <Tooltip text={'Скидка '+this.props.card.student_discount+'% предоставляется только при предъявлении студенческого билета менеджеру клиентского отдела'} />
                    </div>
                    : ''
                }

                {
                  this.props.gift && this.props.gift_title ?
                    <div className="gift">
                      <img src={require("../../static/images/icons/gift-blue.svg").default}/>
                      <div>
                        <div className="title">{this.props.gift_title}</div>
                        <div className="subtitle">{this.props.gift_subtitle}</div>
                      </div>
                    </div>
                    : ''
                }
              </div>

            <div className="your-offer__clubs">
                  <p className={this.props.clubs.gazetniy ? '' : 'your-offer__club-disabled'}>
                      <b>Газетный</b> / Красноармейская, 170
                  </p>
                  <p className={this.props.clubs.gorizont ? '' : 'your-offer__club-disabled'}>
                      <b>Горизонт</b> / пр. М. Нагибина, 32е
                  </p>
                  <p className={this.props.clubs.orbita ? '' : 'your-offer__club-disabled'}>
                      <b>Орбита</b> / Королёва, 10/4
                  </p>
                  {
                      this.props.clubs.millenium || milleniumAdded ?
                        <p><b>Миллениум</b> / Соборный, 94г</p>
                        : (
                          this.props.card.millenium_add_available ?
                          <div className="add-club">
                              <p><b>Миллениум</b> / Соборный, 94г</p>
                              <button onClick={e => this.props.switchMilleniumClub(true)}>
                                  Добавить Миллениум
                              </button>
                          </div> : <div className={(milleniumAddedGlobal ? 'remove' : 'add') + '-club-placeholder-big'}></div>
                        )
                  }
                  {
                      !this.props.clubs.millenium && milleniumAdded ?
                        <div>
                            <button className="remove-club-button" onClick={e => this.props.switchMilleniumClub(false)}>
                                Убрать Миллениум
                            </button>
                        </div> : ''
                  }
                  {
                      this.props.clubs.millenium ?
                        <div className={(milleniumAddedGlobal ? 'remove' : 'add') + '-club-placeholder'}></div> : ''
                  }
              </div>

              <div className={this.props.expandedIncludes ? 'your-offer__includes expanded' : 'your-offer__includes'}>
                  <div className="toggle-button" onClick={() => {
                      expandIncludes(!this.props.expandedIncludes)
                  }}>Включено в тариф</div>
                  {
                      this.props.subscription ?
                        <div className="your-offer__includes__content">
                            <p>Безлимитный
                                доступ {this.props.clubs.millenium || milleniumAdded ? 'во все клубы' : 'в три клуба сети'}</p>
                            <p>Полотенце на время посещения</p>
                            <p>1 гостевой визит ежемесячно</p>
                            <p>Тренажерный зал</p>
                            <p>Бассейн</p>
                            <p>Аквааэробика</p>
                            <p>Групповые тренировки</p>
                            {this.props.clubs.millenium || milleniumAdded ? <p>Анализ состава тела InBody</p> : ''}
                            <p>Персональная тренировка с тренером</p>
                            <p>Финские сауны и хаммам</p>
                            <p>Крутая программа лояльности</p>
                        </div> :
                        <div className="your-offer__includes__content">
                            <p
                              className={this.props.includes.unlimited_access_all_zones ? '' : 'your-offer__club-disabled'}>Безлимитное
                                посещение всех зон
                                клуба {this.props.comfort ? 'в будние дни в определенные часы по данной карте' : ''}
                                {this.props.card.youth ? 'в определенные часы по данной карте' : ''}</p>
                            <p className={this.props.includes.towel ? '' : 'your-offer__club-disabled'}>Полотенце на
                                время посещения</p>
                            <p>Тренажерный зал</p>
                            <p>Бассейн</p>
                            <p>Аквааэробика</p>
                            <p>Групповые тренировки</p>
                            {this.props.card.privileges.pool_personal_trains > 0 ? <p>Персональная тренировка с тренером</p> : ''}
                            <p>Финские сауны и хаммам</p>
                            <p>Крутая программа лояльности</p>
                            {this.props.includes.teen_club_visits ?
                              <p>TEEN-клуб 12+ гостевое / {this.props.includes.teen_club_visits}шт</p> : ''}
                            <p
                              className={this.props.includes.kids ? '' : 'your-offer__club-disabled'}>{this.props.clubs.millenium || milleniumAdded ? 'Детский центр Школаториум 3+' : 'Детский центр 6+'} гостевое/ 1шт</p>
                            <p
                              className={(milleniumAdded && this.props.millenium_privileges.cycle) || (!milleniumAdded && this.props.includes.cycle) ? '' : 'your-offer__club-disabled'}>Интерактивная
                                Cycle-студия</p>
                            <p
                              className={(milleniumAdded && this.props.millenium_privileges.inbody) || (!milleniumAdded && this.props.includes.inbody) ? '' : 'your-offer__club-disabled'}>Анализ
                                состава тела In‑Body / 1шт</p>
                            {/*<p className={this.props.includes.freezing_30_days ? '' : 'your-offer__club-disabled'}>Заморозка 30 дней</p>*/}
                        </div>
                  }
              </div>

              <button
                type="button"
                onClick={() => {
                    setResultCard({...this.props.card});
                    eventSelectCard({...this.props.card});
                    /*
                    if (document.getElementsByClassName('marquiz-widget').length > 0) {
                        document.getElementsByClassName('marquiz-widget')[0].style.display = 'none'
                    }
                    if (document.getElementsByClassName('marquiz__bg').length > 0) {
                        document.getElementsByClassName('marquiz__bg')[0].style.display = 'none'
                    }
                     */
                    history.push('/processing/' + this.props.card.slug);
                }}
              >Выбрать</button>
          </div>
        )
    }
}

function mapStateToProps(state, props) {
    return {
      milleniumAdded: state.card.milleniumAdded && props.card.millenium_add_available,
      milleniumAddedGlobal: state.card.milleniumAdded,
      installmentDiscount: state.card.installmentDiscount,
      studentStatus: state.card.studentStatus
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    switchMilleniumClub,
    switchInstallmentDiscount,
    openModal,
    changeTypeOfModal,
    setResultCard,
    saveModalInfo,
    setPromocode,
    setStudentStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Card);